import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-servicios-entidades',
  templateUrl: './servicios-entidades.component.html',
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '0px',
      })),
      state('closed', style({
        right: '-293px',
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.1s')
      ]),
    ]),
    trigger('openCloseToolTip', [
      state('open', style({
        opacity: '1',
      })),
      state('closed', style({
        opacity: '0',
      })),
      transition('open => closed', [
        animate('0.7s')
      ]),
      transition('closed => open', [
        animate('0.1s')
      ]),
    ]),
  ],
  styleUrls: ['./servicios-entidades.component.scss']
})
export class ServiciosEntidadesComponent implements OnInit {

  showToolTip: boolean = true;
  enableToolTip: boolean = true;
  showSevicios: boolean = false;
  urlPlanIntegracion = environment.urlPlanIntegracion;
  urlCajaHerramientas = environment.urlCajadeHerramientas;
  urlBiblioteca = environment.urlBiblioteca;

  constructor() {
    //Empty Function
  }

  ngOnInit() {
    interval(5000).pipe(take(1)).subscribe(resp => {
      this.showToolTip = false;
    })
  }

  eventoOver(event) {
    if (event.type === "mouseover") {
      if (!this.showToolTip) {
        this.showToolTip = true;
        this.enableToolTip = this.showSevicios ? false : true;
      }
    } else {
      if (this.showToolTip) {
        this.showToolTip = false;
        this.enableToolTip = false;
      }
    }
  }

  onAnimationEvent = () => this.enableToolTip = !this.showToolTip ? false : true;

  mostarMenu() {
    this.showSevicios = !this.showSevicios;
    this.enableToolTip = false;
  }
}
